import React from 'react';

export const WarningIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" focusable="false" aria-hidden="true">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m29.887 28.539-13-25a1 1 0 0 0-1.774 0l-13 25A1 1 0 0 0 3 30h26a1 1 0 0 0 .887-1.461zM14.875 11h2.25v10h-2.25V11zM16 27a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
      fill="currentColor"
    />
  </svg>
);
